import React from 'react';
import { useNavigate } from 'react-router-dom';

// =========================================================================
// এখানে আপনার ৬টি ক্লাসের ইউটিউব লিংক এবং টাইটেল বসিয়ে নিন
// =========================================================================
const videoCardsData = [
  { id: '1', title: 'Class 1', videoUrl: 'https://www.youtube.com/embed/lTRiuFIWV54' },
  { id: '2', title: 'Class 2', videoUrl: 'https://www.youtube.com/embed/lTRiuFIWV54' },
  { id: '3', title: 'Class 3', videoUrl: 'https://www.youtube.com/embed/lTRiuFIWV54' },
  { id: '4', title: 'Class 4', videoUrl: 'https://www.youtube.com/embed/lTRiuFIWV54' },
  { id: '5', title: 'Class 5', videoUrl: 'https://www.youtube.com/embed/lTRiuFIWV54' },
  { id: '6', title: 'Class 6', videoUrl: 'https://www.youtube.com/embed/lTRiuFIWV54' },
];

const getEmbedUrl = (urlStr) => {
  if (!urlStr) return '';
  if (urlStr.includes('embed/')) return urlStr;

  let videoId = '';
  if (urlStr.includes('youtu.be/')) {
    videoId = urlStr.split('youtu.be/')[1]?.split('?')[0];
  } else if (urlStr.includes('watch?v=')) {
    videoId = urlStr.split('watch?v=')[1]?.split('&')[0];
  } else {
    videoId = urlStr;
  }

  return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&showinfo=0`;
};

const WorkflowScreen = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <style>{`
        * { box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }

        html, body {
          overscroll-behavior-y: none;
          overflow: hidden;
          margin: 0;
          padding: 0;
        }

        .workflow-shell {
          width: 100%;
          max-width: 480px;
          height: 100dvh;
          background: #f1f5f9;
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;
          box-shadow: 0 0 40px rgba(0,0,0,0.04);
        }
        @media (min-width: 768px) {
          .workflow-shell { height: 92vh; border-radius: 36px; border: 1px solid #e2e8f0; }
        }

        /* ১০০% লকড ফিক্সড হেডার (কখনো সরবে না) */
        .fixed-top-header {
          padding: 16px 20px;
          background: #ffffff;
          display: flex;
          align-items: center;
          gap: 16px;
          border-bottom: 1px solid #e2e8f0;
          flex-shrink: 0;
          z-index: 30;
        }

        /* স্বাধীন স্ক্রলিং ভিডিও ফিড */
        .videos-scroll-area {
          flex: 1;
          overflow-y: auto;
          overscroll-behavior-y: contain;
          padding: 16px;
          display: flex;
          flex-direction: column;
          gap: 20px;
          -webkit-overflow-scrolling: touch;
        }

        /* স্ক্রিনে পারফেক্ট ২টি কার্ড ফিট হওয়ার প্রিমিয়াম কার্ড সায়জ (flex-shrink: 0) */
        .class-card {
          background: #ffffff;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
          border: 1px solid #e2e8f0;
          display: flex;
          flex-direction: column;
          flex-shrink: 0; /* কার্ড চেপ্টা হওয়া রোদ করবে */
          width: 100%;
        }

        /* ভিডিও প্লেয়ার ফ্রেম (স্থায়ী ২০০px উচ্চতা) */
        .video-box-frame {
          width: 100%;
          height: 200px;
          background: #000000;
          position: relative;
          flex-shrink: 0;
        }

        .video-box-frame iframe {
          width: 100%;
          height: 100%;
          border: none;
        }

        /* টাইটেল প্যানেল (ভিডিওর নিচে সাদা অংশ) */
        .title-panel-box {
          padding: 14px 16px;
          background: #ffffff;
          text-align: center;
          border-top: 1px solid #f1f5f9;
          flex-shrink: 0;
        }
      `}</style>

      <div className="workflow-shell">
        
        {/* ১০০% লকড হেডার */}
        <div className="fixed-top-header">
          <button onClick={() => navigate('/dashboard')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0f172a" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
          </button>
          <div>
            <h2 style={{ fontSize: '18px', fontWeight: '800', margin: 0, color: '#0f172a' }}>সকল প্রয়োজনীয় ভিডিও</h2>
            <span style={{ fontSize: '11px', color: '#62b875', fontWeight: '700' }}>Nexora Video Learning</span>
          </div>
        </div>

        {/* স্ক্রিনে স্থায়ীভাবে ২টি ভিডিও কার্ড দেখা যাবে (বাকিগুলো নিচে স্ক্রলযোগ্য) */}
        <div className="videos-scroll-area">
          {videoCardsData.map((card) => {
            const embedUrl = getEmbedUrl(card.videoUrl);

            return (
              <div key={card.id} className="class-card">
                
                {/* ২00px উচু ভিডিও প্লেয়ার */}
                <div className="video-box-frame">
                  <iframe 
                    src={embedUrl} 
                    title={card.title} 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen 
                  />
                </div>

                {/* ভিডিওর নিচের সাদা টাইটেল লেখার জায়গা */}
                <div className="title-panel-box">
                  <h4 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#334155' }}>
                    {card.title}
                  </h4>
                </div>

              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', backgroundColor: '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'center' }
};

export default WorkflowScreen;